import React from 'react';
import { useAuth } from '../../Services/AuthContext';
import { useFetchEntitySingle } from '../../Services/fetchApi';
import entities from '../../utils/entities';
import {Button, Row, Col } from 'reactstrap';
import { useState } from 'react';
import Editor from '../Models/Editor';
import { FormValue, FormLabel } from '../Form/FormLabel';
import LoadingAnimation from '../Form/LoadingAnimation';

const MarginDetails = ({ id , route}) => {
    const [auth] = useAuth();
    const [details, loading, error] = useFetchEntitySingle(entities.marginDetails, id,true);
    const [editMargin, setEdit] = useState(false)
    const editMargins = () => {
        const marginItems = details.marginItems.map((x) => { return { ...x, usePercent: x.percentage > 0 } }); 
        const eDetails = { ...details, marginItems }; 
        setEdit(eDetails);
    }
    const marginDescription = details?.marginOwnership === 'ParentClient' ? 'This Margin setting for this user is defined in the master Client':
        details?.marginOwnership === 'ParentDepartment' ? 'This Margin setting for this user is defined in the master department' :
        details?.marginOwnership === 'Self'? 'This margin setting is defined for this client':'There is no margin setting for this user, so we are using the default margin (10%)'


    return auth.role === 'Admin' ? 
        details ? <React.Fragment>
            {error ? <h6>Error Loading</h6> : null}
            {loading ? <LoadingAnimation /> : null}
            {editMargin && <Editor edit route={route} entity={entities.marginDetails} newItem={editMargin} editorClosed={() => setEdit(false)} />}
            < h6 > {marginDescription}</h6>
            <Row>
                <Col>
                    <FormLabel>Min</FormLabel>
                </Col>
                <Col>
                    <FormLabel>Max</FormLabel>
                </Col>
                <Col>
                </Col>
                <Col>
                    <FormLabel>Margin</FormLabel>
               </Col>
                <Col>
                   
                </Col>
            </Row>
            {
                details.marginItems?.map((x, i) => {
                    return <Row key={i}>
                        <Col>
                            <FormValue>{x.minRange}</FormValue>   
                        </Col>
                        <Col>
                            <FormValue>{x.maxRange}</FormValue> 
                        </Col>
                        <Col>           
                            <FormValue>
                                {x.percentage > 0 ? x.percentage + '%' : '$' + x.price}
                            </FormValue>
                        </Col>
                        
                    </Row>
                })
            }
            <Button onClick={ editMargins}>Edit Margins</Button>
        </React.Fragment> : <LoadingAnimation height={'50px'} /> 
        : <h1>You should not be here!</h1>; 

}

export default MarginDetails;
